document.addEventListener("DOMContentLoaded", function () {
  gsap.registerPlugin(ScrollTrigger);

  const textRevealContainer = document.getElementById("textRevealContainer");
  const textContent = document.getElementById("textContent");
  const text = textRevealContainer.getAttribute("data-text");

  const words = text.split(" ");

  // Clear previous content
  textContent.innerHTML = "";

  // Create word structure
  words.forEach((word) => {
    const wordContainer = document.createElement("div");
    wordContainer.className = "word-container";

    const wordVisible = document.createElement("span");
    wordVisible.className = "word-visible";
    wordVisible.textContent = word;

    wordContainer.appendChild(wordVisible);
    textContent.appendChild(wordContainer);
  });

  // Select all words
  const allWords = document.querySelectorAll(".word-visible");
  const wordElementsMiviAi = document.querySelectorAll(
    ".mivi-ai .word-visible"
  );

  // Exclude .mivi-ai words from main wordElements
  const wordElements = Array.from(allWords).filter(
    (el) => !el.closest(".mivi-ai")
  );

  const totalWords = wordElements.length + wordElementsMiviAi.length;

  // Master timeline with scrollTrigger
  const masterTimeline = gsap.timeline({
    scrollTrigger: {
      trigger: ".text-reveal-wrapper",
      start: "top 90%",
      end: "+=500",
      scrub: 1,
      pin: false,
      markers: false,
    },
  });

  // Animate regular words
  wordElements.forEach((word, index) => {
    const wordDuration = 1 / totalWords;
    const startPosition = index * wordDuration;

    masterTimeline.fromTo(
      word,
      { opacity: 1, color: "#C4CCC4" },
      {
        opacity: 1,
        color: "#000000",
        duration: wordDuration,
        ease: "power2.inOut",
      },
      startPosition
    );
  });

  // Animate .mivi-ai words
  wordElementsMiviAi.forEach((word, index) => {
    const wordDuration = 1 / totalWords;
    const startPosition = (wordElements.length + index) * wordDuration;

    masterTimeline.fromTo(
      word,
      { opacity: 1, color: "#343B36" },
      {
        opacity: 1,
        color: "#ffffff",
        duration: wordDuration,
        ease: "power2.inOut",
      },
      startPosition
    );
  });

  // Background color scroll effect
  gsap.to(".index .animated-text-heading-parent", {
    backgroundColor: "#fff",
    scrollTrigger: {
      trigger: ".index .word-visible",
      start: "top 100%",
      end: "top 10%",
      toggleActions: "play none none reverse",
    },
  });
});
